// extracted by mini-css-extract-plugin
export default {"text-header":"PlansBlock_text-header__G9Ypj","padding":"PlansBlock_padding__ckYw8","plans":"PlansBlock_plans__NV4Zw"};